import { useState } from 'react';

import { ArchiveDropdown } from 'pages/Workshop/components/ArchiveDropdown';
import { TabLabel } from 'pages/Workshop/components/TabLabel';
import { WorkshopTabsTable } from 'pages/Workshop/components/WorkshopTabsTable';

import styles from '../OffersTable/styles.module.scss';

import { WorkshopPageTabs } from 'pages/Workshop/components/WorkshopPageTabs';
import {
  emptyText,
  getArchivedOffersDetails,
  getArchivedOffersOptions,
  OFFER_TABS,
  prepareOffersData,
} from './helper';
import { tableColumns } from '../OffersTable/tableColumns';
import { useHistory } from 'react-router-dom';
import { link } from 'settings/navigation/link';

export const OfferTabs = (tabProps) => {
  const [archivedValue, setArchivedValue] = useState('');
  const [activeKey, setActiveKey] = useState(OFFER_TABS.New);

  const { isPending, offerAggregate } = tabProps;

  const history = useHistory();

  if (isPending) return <></>;

  const dataItems = prepareOffersData({ offerAggregate });

  const { newOffer, pending, counterReceived, counterSent, archivedOffers } = dataItems;

  const { dataSource: archivedDataSource, columns } = getArchivedOffersDetails(
    archivedValue,
    archivedOffers,
  );

  const redirectToOffers = (data) => {
    return history.push({
      pathname: link.toTransactionOffers(data?.PropertyId),
      state: {
        offerIterationUUID: data?.LatestOfferIteration?.UUID,
        triggerOfferDetail: true,
      },
    });
  };

  const tableProps = {
    columns: tableColumns(false, false, undefined),
    onRow: (record) => {
      return {
        onClick: () => {
          redirectToOffers(record);
        },
      };
    },
    tableClassName: styles.OffersTable,
  };

  const tabItems = [
    {
      key: OFFER_TABS.New,
      label: <TabLabel title={OFFER_TABS.New} count={newOffer.length} />,
      children: <WorkshopTabsTable {...tableProps} dataSource={newOffer} emptyText={emptyText} />,
    },
    {
      key: OFFER_TABS.Pending,
      label: <TabLabel title={OFFER_TABS.Pending} count={pending.length} />,
      children: <WorkshopTabsTable {...tableProps} dataSource={pending} emptyText={emptyText} />,
    },
    {
      key: OFFER_TABS.CounterReceived,
      label: <TabLabel title={OFFER_TABS.CounterReceived} count={counterReceived.length} />,
      children: (
        <WorkshopTabsTable {...tableProps} dataSource={counterReceived} emptyText={emptyText} />
      ),
    },
    {
      key: OFFER_TABS.CounterSent,
      label: <TabLabel title={OFFER_TABS.CounterSent} count={counterSent.length} />,
      children: (
        <WorkshopTabsTable {...tableProps} dataSource={counterSent} emptyText={emptyText} />
      ),
    },
    {
      key: OFFER_TABS.Archive,
      label: (
        <ArchiveDropdown
          archivedValue={archivedValue}
          setArchivedValue={(value) => {
            setArchivedValue(value);
            setActiveKey(OFFER_TABS.Archive);
          }}
          archivedData={archivedDataSource}
          dropdownOptions={getArchivedOffersOptions(archivedOffers)}
        />
      ),
      children: archivedValue ? (
        <WorkshopTabsTable
          {...tableProps}
          columns={columns}
          dataSource={archivedDataSource}
          emptyText={emptyText}
        />
      ) : null,
    },
  ];

  return (
    <div>
      <WorkshopPageTabs
        activeKey={activeKey}
        items={tabItems}
        onChange={(value) => {
          if (archivedValue && value !== OFFER_TABS.Archive) {
            setArchivedValue('');
            setActiveKey(value);
          }

          value !== OFFER_TABS.Archive && setActiveKey(value);
        }}
      />
    </div>
  );
};
